module.exports = __webpack_public_path__ + "img/scroll_up.85c1b3f7.svg";